import {
  getStoredSelectedAddressId,
} from '../Cart/cartDistanceUtils';
import { findSelectedDeliveryAddress } from '../Account/Addresses/addressManagementUtils';

/** @param {{ address?: string, city?: string, state?: string, postalCode?: string }} address */
export function savedAddressToCheckoutForm(address) {
  return {
    address1: String(address.address || '').trim(),
    address2: '',
    city: String(address.city || '').trim(),
    state: String(address.state || '').trim(),
    pincode: String(address.postalCode || '').trim(),
  };
}

/**
 * @param {Array<{ id: number | null, isPrimary?: boolean, latitude: number | null, longitude: number | null }>} addresses
 * @returns {number | null}
 */
export function resolveInitialSelectedAddressId(addresses) {
  const stored = getStoredSelectedAddressId();
  if (findSelectedDeliveryAddress(addresses, stored) != null) return stored;

  const withCoords = addresses.filter(
    (a) => Number.isFinite(a.latitude) && Number.isFinite(a.longitude),
  );
  const primary = withCoords.find((a) => a.isPrimary);
  if (primary?.id != null) return primary.id;
  return withCoords[0]?.id ?? null;
}

/**
 * Preserve saved-address display order (API / account list). Selection is shown via tile styling only.
 * @param {Array<{ id: number | null }>} addresses
 */
export function sortAddressesForCheckout(addresses) {
  return [...addresses];
}
